<template>
  <div class="pacuns">
    <div class="pacuns-background">
      <div class="appHelmetysen">优惠券<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="pacuns-persal">
        <div class="pacuns-content" v-for="erpacoma in pacoma" :key="erpacoma.ID">
          <div class="pacuns-content-left">
            <p class="pacuns-content-left-title">{{erpacoma.COUPONS_NAME}}</p>
            <p class="pacuns-content-left-time">到期时间: {{erpacoma.END_DATE}}</p>
            <p class="pacuns-content-left-time pacuns-content-left-text" @click="paexdr(erpacoma.NOTE)">使用规则: {{erpacoma.NOTE}}</p>
          </div>
          <div class="pacuns-content-right">
            <p>{{erpacoma.VALUEOF}}</p>
            <button @click="patose(erpacoma.COUPONS_NAME,erpacoma.END_DATE,erpacoma.COUPONS_NUMBER)">去使用</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 使用规则 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + pasthint">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">使用规则</div>
        <div class="weui-dialog__bd">{{pasrul}}</div>
        <div class="weui-dialog__ft">
          <a role="button" href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #FF4D4D;" @click="paclse()">完成</a>
        </div>
      </div>
    </div>
    <!-- 去使用 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + pasthise">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">{{pacome}}</div>
        <div class="weui-dialog__bd">有效期至 {{patrdy}}</div>
        <div id="qrcode" class="pacuns-copd"></div>
        <div class="weui-dialog__bd">券码: {{pacode}}</div>
        <div class="weui-dialog__bd">为保障您的权益,未到店消费前请不要将券号提供给商家。</div>
        <div class="weui-dialog__ft">
          <a role="button" href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #FF4D4D;" @click="paclse()">完成</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
import QRCode from 'qrcodejs2';
export default {
  data(){
    return{
      loginID: '',
      pasthint: 'none',
      pasthise: 'none',
      pacoma: '',
      pacome: '',
      patrdy: '',
      pacode: '',
      pasrul: ''
    }
  },
  created(){
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 优惠券
    this.$axios.post('app/coupons/listcouponsPackage',this.$qs.stringify({
      MEMBER_ID: this.loginID,
      STATE: '0'
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.pacoma = res.data.varList;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
     
  },
  methods:{
    // 把卡号生成二维码
    showQrcode(scpode){
      this.$('#qrcode').html("");
      this.qrcode = new QRCode('qrcode', { // 第一个入参是组件id
        text: scpode, // 生成二维码的文本
        width: 210,
        height: 210,
        colorDark: '#000000', // 二维码色
        colorLight: '#ffffff', // 背景色
        correctLevel: QRCode.CorrectLevel.H // 容错等级，H是heigh，最高，所以二维码看起来很密
      })
    },
    // 点击展开
    paexdr(ures){
      this.pasrul = ures;
      this.pasthint = 'block';
    },
    // 点击完成触发
    paclse(){
      this.pasthint = 'none';
      this.pasthise = 'none';
    },
    // 点击去使用触发
    patose(cume,term,cpde){
      this.pacome = cume;
      this.patrdy = term;
      this.pacode = cpde;
      this.showQrcode(cpde);
      this.pasthise = 'block';
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/pacuns.css";
</style>